import { projectName } from 'modules/Casino/utils/slots';
import BaseApi from '../BaseApi';
import { AssistantConverter } from './AssistantConverter';
import { parseCookies } from 'modules/Casino/utils/parseCookies';

class AssistantApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/agent_admin`;
    this.parseUrl = `${baseUrl}/semantic/parse`;
    this.converter = new AssistantConverter();
  }

  getAuthHeaders = () => ({
    headers: {
      'x-partner-name': 'staging_ganamos',
      'x-partner-authorization': parseCookies(),
    },
  });

  getTableData = data =>
    this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/assistant`, data, this.getAuthHeaders(), result =>
      this.converter.convertTableData(result, data?.action),
    );

  parseText = text => this.sendQuery(this.queryTypes.POST, this.parseUrl, { raw_query: text }, this.getAuthHeaders());
}

export default AssistantApi;
